export default "__VITE_ASSET__fcb8b209__"